<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsReport-skuInvFtyLocation',
  components: {
    PageTable
  }
}
</script>
